module.exports = __webpack_public_path__ + "img/StringInverter.e51f387c.png";